import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { RestrictedModeService } from '../../../modules/feature-toggle/services/restricted-mode.service';
import { PaymentWallComponent } from '../../component/payment-wall/payment-wall.component';

/**
 * Service that manages the PaymentWall blocking dialog.
 * Automatically opens the dialog when subscription enters 'Suspended' phase.
 * Follows the UpdateDialogService pattern.
 */
@Injectable({ providedIn: 'root' })
export class PaymentWallDialogService {

  private suspendedSubject = new BehaviorSubject<boolean>(false);
  suspended$ = this.suspendedSubject.asObservable();

  private currentDialogRef: MatDialogRef<PaymentWallComponent> | null = null;

  constructor(
    private dialog: MatDialog,
    private restrictedModeService: RestrictedModeService
  ) {
    // Auto-trigger: open/close dialog based on subscription phase
    this.restrictedModeService.isSuspended$.pipe(
      distinctUntilChanged()
    ).subscribe(isSuspended => {
      if (isSuspended) {
        this.showPaymentWall();
      } else {
        this.clearPaymentWall();
      }
    });
  }

  showPaymentWall(): void {
    this.suspendedSubject.next(true);

    // Prevent duplicate dialogs
    if (this.currentDialogRef) return;

    this.currentDialogRef = this.dialog.open(PaymentWallComponent, {
      disableClose: true,
      maxWidth: '95vw',
      width: '450px'
    });

    this.currentDialogRef.afterClosed().subscribe(() => {
      this.currentDialogRef = null;
    });
  }

  clearPaymentWall(): void {
    this.suspendedSubject.next(false);
    if (this.currentDialogRef) {
      this.currentDialogRef.close();
      this.currentDialogRef = null;
    }
  }
}
